module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf.dd7850ae.svg";